<script>
  import { user } from "../stores/user.js"; // adjust path according to your project structure
  import { createEventDispatcher } from "svelte";
  import { padding } from "../utils/utils.js";
  import { formData } from "../stores/formData.js";
  import { showResultSection } from "../stores/showResultSection.js";
  import ConfirmationDialog from "./ConfirmationDialog.svelte";

  let showConfirmationDialog = false;
  let idToDelete = null;

  const local_api_url = "https://astro.astrosofica.nl/php/userlist.php";
  let data = [];
  let listHasData = false;

  const dispatch = createEventDispatcher();
  // Prop to control visibility from parent
  export let show = false;
  const close = () => {
    dispatch("close");
  };

  $: if ($user && $user.token) {
    getData();
  }

  async function getData() {
    const response = await fetch(local_api_url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: $user.token }),
    });

    if (response.ok) {
      const result = await response.json();
      data = result;
      listHasData = true;
    } else {
      console.error(`API request failed with status ${response.status}`);
    }
  }

  function handleOpen(id) {
    const rowData = data.find((item) => item.id === id);
    if (rowData) {
      // rowData now contains the data object associated with the provided id
      const name = rowData.name;
      const date =
        rowData.year +
        "-" +
        padding(rowData.month) +
        "-" +
        padding(rowData.day);
      const time =
        padding(rowData.hour) +
        ":" +
        padding(rowData.minute) +
        ":" +
        padding(rowData.second);
      const location = rowData.place;
      // set the store..
      formData.update(() => ({
        id,
        name,
        date,
        time,
        location,
        isSet: true,
        isInitiated: false,
        reset: false,
      }));
      showResultSection.set(false);
      close();
    } else {
      // No matching id found in the data
      console.log("error: id doesn't exsist");
    }
  }

  const handleDelete = (id) => {
    idToDelete = id; // Save the id to delete
    showConfirmationDialog = true; // Show the confirmation dialog
  };

  async function deleteRow(id) {
    // function to delete a row with id = id
    let token = $user.token;

    // Define the URL for your API
    let deleteApiUrl = "https://astro.astrosofica.nl/php/userdatadelete.php";

    // Define the data you want to send
    let data = {
      id: id,
      token: token,
    };

    // Send a POST request to your API
    let response = await fetch(deleteApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (response.statusText === "OK") {
      // The request was successful
      console.log("Data deleted successfully");
      // We need to load the list modal..
      getData();
    } else if (response.error) {
      // The API returned an error
      console.log("API Error:", response.error);
      // need some proper errorhandling.. :-(
    }
  }

  const onConfirm = () => {
    deleteRow(idToDelete); // Delete the row
    showConfirmationDialog = false; // Hide the confirmation dialog
    idToDelete = null; // Clear the id
  };

  const onCancel = () => {
    showConfirmationDialog = false; // Hide the confirmation dialog
    idToDelete = null; // Clear the id
  };

  function resetForm() {
    // empty store "formData"
    formData.update(() => ({
      id: "",
      name: "",
      date: "",
      time: "",
      location: "",
      isSet: true,
      isInitiated: false,
      reset: true,
    }));
    showResultSection.set(false);
    close();
  }
</script>

{#if showConfirmationDialog}
  <ConfirmationDialog
    message="Weet je zeker dat je deze horoscoop wilt verwijderen?"
    on:confirm={onConfirm}
    on:cancel={onCancel}
  />
{/if}
<!-- display the data -->
<div class="modal" style="display: {show ? 'flex' : 'none'}">
  <div class="backdrop" on:click={close} on:keydown={close} />
  <div class="content">
    <button class="close-button" on:click={close}>X</button>
    {#if listHasData && data.length > 0}
      <table>
        <thead>
          <tr>
            <th>Naam</th>
            <th>Datum</th>
            <th class="desktop">Tijd</th>
            <th>Opties</th>
          </tr>
        </thead>
        <tbody>
          {#each data as row (row.id)}
            <tr>
              <td>{row.name}</td>
              <td>{padding(row.day)}-{padding(row.month)}-{row.year}</td>
              <td class="desktop">
                {padding(row.hour)}:{padding(row.minute)}:{padding(row.second)}
              </td>
              <td>
                <button class="list-button" on:click={() => handleOpen(row.id)}
                  >Open</button
                >
                <button
                  class="list-button"
                  on:click={() => handleDelete(row.id)}>Delete</button
                >
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    {:else}
      Nog geen data, sla een horoscoop op.<br />Dit doe je door een horoscoop in
      te voeren. Na het zoeken naar coordinaten kun je kiezen om op te slaan.
    {/if}
    <div>
      <button class="new-button" on:click={resetForm}
        >Maak een nieuwe horoscoop aan.</button
      >
    </div>
  </div>
</div>

<style>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }

  .backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .content {
    position: relative;
    background: white;
    padding: 2em;
    width: 80%;
    max-width: 500px;
    z-index: 1000;
    border-radius: 5px;
  }

  .close-button {
    position: absolute;
    right: 1em;
    top: 0.5em;
  }
  .list-button {
    padding-top: 0px;
    padding-bottom: 3px;
    margin-top: 3px;
    margin-bottom: 3px;
    font-size: small;
  }
  .new-button {
    margin-top: 10px;
    width: 100%;
    margin: auto;
    text-align: center;
    background-color: #bad095;
  }

  button:hover {
    background-color: #dde8ca;
    border-color: darkolivegreen;
  }
  @media (max-width: 430px) {
    .desktop {
      display: none;
    }
  }
</style>
